import React, { useState, useEffect } from "react";
import {  useAuth0 } from "@auth0/auth0-react";
import AdSense from "../Home/Adsense";
import { Helmet } from "react-helmet-async";
import { saveAs } from 'file-saver';
export default function App() {

  const [bookmarks, setBookmarks] = useState([]);

  const handleBookmarkSubmit = (e) => {
    e.preventDefault();
    const siteNameInput = e.target.siteNameInput.value;
    const siteUrlInput = e.target.siteUrlInput.value;
    if (!siteNameInput.trim()) {
      // Show error message for site name input
      const errMsg = document.getElementById("siteNameErrMsg");
      errMsg.innerText = "Please enter a site name.";
      setTimeout(() => {
        errMsg.innerText = "";
      }, 3000);
      return;
    } else if (!siteUrlInput.trim()) {
      // Show error message for site URL input
      const errMsg = document.getElementById("siteUrlErrMsg");
      errMsg.innerText = "Please enter a site URL.";
      setTimeout(() => {
        errMsg.innerText = "";
      }, 3000);
      return;
    }
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    if (!urlRegex.test(siteUrlInput)) {
      // Show error message for invalid site URL
      const errMsg = document.getElementById("siteUrlErrMsg");
      errMsg.innerText = "Please enter a valid site URL.";
      setTimeout(() => {
        errMsg.innerText = "";
      }, 3000);
      return;
    }  
    const newBookmark = {
    
      id: Date.now(),
      siteName: siteNameInput,
      siteUrl: siteUrlInput,
    };
    setBookmarks([...bookmarks, newBookmark]);
    e.target.reset();
  };

  const handleBookmarkDelete = (id) => {
    const updatedBookmarks = bookmarks.filter((bookmark) => bookmark.id !== id);
    setBookmarks(updatedBookmarks);
  };

  const generateBookmarkHTML = () => {
    const date = new Date();
    const ADD_DATE = date.getTime().toString();
    let html = '<DL><p>\n';
  
    html += `<DT><H3 ADD_DATE="${ADD_DATE}" LAST_MODIFIED="${ADD_DATE}" PERSONAL_TOOLBAR_FOLDER="true">Bookmarks bar</H3>\n`;

    bookmarks.forEach((bookmark) => {
      html += `<DT><A HREF="${bookmark.siteUrl}" ADD_DATE="${ADD_DATE}" ICON="">${bookmark.siteName}</A>\n`;
    });

    html += '</DL><p>';

    return html;
  };

  const handleDownload = () => {
    const htmlContent = generateBookmarkHTML();
    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
    saveAs(blob, 'DesireStore-Bookmarker.html');
  };

  
  useEffect(() => {
    const savedBookmarks = localStorage.getItem("bookmarks");
    if (savedBookmarks) {
      setBookmarks(JSON.parse(savedBookmarks));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
  }, [bookmarks]);

  const removeAll = () => {
    const confirmed = window.confirm("Do you really want to remove all bookmarks?");
  
    if (confirmed) {
      setBookmarks([]);
    }
  };
  const {user,isAuthenticated } = useAuth0();

  
  return (
    <>
    <Helmet>
        <title>Organize Your Online Life with Our Free Bookmarking Too</title>
        <meta property="og:title" content="Organize Your Online Life with Our Free Bookmarking Too"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/bookmark"/>
        <meta property="og:description" content="Simplify your online browsing experience and keep all your favorite websites in one place with our free bookmarking tool. No more endless scrolling through your browser history or trying to remember that one website you found last week. With our tool, you can easily save and organize your favorite websites into folders and access them with just a click. Plus, with the ability to sync your bookmarks across devices, you can easily access your favorite websites from anywhere. Sign up today and start streamlining your online life."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>

        <link rel="canonical" href="https://desirestore.online/bookmark" />
        <meta name="title" content="Organize Your Online Life with Our Free Bookmarking Too"/>
        <meta name="description"  content=" Download the latest ISO files for Windows 10, Windows 11 Lite, and Ubuntu from our website. Our collection includes the most recent releases of these popular operating systems, all available for free download. With our easy-to-use interface, you can quickly and easily select the ISO file you need and start the download process. Whether you're a student, a professional, or just an everyday user, our website has everything you need to get started with these powerful and versatile operating systems."/>
        <meta name="keywords" content="Bookmarker, online browsing, favorite websites, bookmarking tool, organize, folders, access, sync, devices, online life, simplify."/>
      </Helmet>
    <div className="container" id="BookMakrContainer">

 
      <div className="bookmark">
      <div className="row">
        <div className="col-12 mt-3">
          <div className="heading">
            <h1>Hello, {isAuthenticated ? (user ? user.nickname : "") : "User"}!</h1> </div>
          <div className="p-3 formContainer">
            <h1>
             Let's Bookmark Your <span>Favorite Sites</span>{" "}
            </h1>
            <form
              className="boxContainer"
              id="bookmarkForm"
              onSubmit={handleBookmarkSubmit}
            >
              <label htmlFor="siteNameInput">SITE NAME</label>
              <input
                className="form-control"
                placeholder="Enter site name"
                type="text"
                id="siteNameInput"
                
              />
              <p id="siteNameErrMsg"></p>
              <label htmlFor="siteUrlInput">SITE URL</label>
              <input
                className="form-control"
                placeholder="Enter site url"
                type="text"
                id="siteUrlInput"
              />
              <p id="siteUrlErrMsg"></p>
              <div className="text-right">
                <button className="deleteBtn" id="clearBtn" type="reset">
                  Clear
                </button>
                <button className="submitBtn" id="submitBtn" type="submit">
                  Submit
                </button>
              </div>
            </form>
            <div className="boxContainer" id="boxCont">
            {bookmarks.length > 0 ? (
  <>
    <ul id="bookmarksList">
      {bookmarks.map((bookmark) => (
        <li key={bookmark.id}>
          <h3>{bookmark.siteName}</h3> 
          <a href={bookmark.siteUrl} className="siteUrl">{bookmark.siteUrl}</a>
          <span className="btnDelete">
            <button
              className="deleteBtn"
              id="deleteTrash"
              onClick={() => handleBookmarkDelete(bookmark.id)}
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </span>
        </li>
        
      ))
      }
    </ul>
    <div className="text-right">
     <li className="removebtn"><button className="deleteBtn" onClick={removeAll}>Remove All</button></li>
 
     <li className="downloadbtn">
          <button className="downloadBtn" onClick={handleDownload}>Download HTML</button>
        </li>
    </div>
  </>
) : (
  <p>No bookmarks to display</p>
)}

            </div>
          </div>
        </div>
      </div>
      
    </div>
    
    <AdSense/>
    </div></>
  );
}
